export default  {
    PERFORMANCE_OBLIGATION_ORIGIN: 'REV_DEFERRAL',
    REVENUE: 'REVENUE',

    COM_DEFERRAL: 'COM_DEFERRAL',
    COM_EXPENSE: 'COM_EXPENSE',

    EXP_DEFERRAL: 'EXP_DEFERRAL',
    EXP_RECOGNIZED: 'EXP_RECOGNIZED',

    DEFERRED_REVENUE_RECLASS_TO_UNBILLED_RECEIVABLE: 'DREV_RECLASS_UR',
    UNBILLED_RECEIVABLE_REVERSAL: 'UR_REVERSAL'
}